var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.classes},[_c('div',{class:{
      'padding-t-1 padding-b-1': _vm.padLabelVertical,
      'padding-l-1 padding-r-1': _vm.padLabelHorizontal,
    }},[_vm._v(" "+_vm._s(_vm.label)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }